import usePath from "./usePath";


const useInitialState = (siteMenuItems, props) => {
    const { serverData } = props;
    const location = usePath(window.location.pathname.toLowerCase(),serverData);
    //console.info(`useInitialState useing location '${location}' for path '${window.location.pathname.toLowerCase()}'`, siteMenuItems);
    let accordionindex = -1;
    let menuIndex = -1;
    let subMenuIndex = -1;
    //console.info(`Nav construct looking for ${location}`);
    if (location.length !== 0 && location !== "/") {
        const accordions = siteMenuItems;
        //console.info(`Nav construct checking accordions`, accordions);
        for (let accordionIndex = 0; accordionIndex < accordions.length; accordionIndex++) {//for each accordion
            const accordion = accordions[accordionIndex];
            //console.info(`Nav construct checking accordion '${accordion.label}'`, accordion);
            if (accordion.url && accordion.url.toLowerCase() == location) {
                accordionindex = accordionIndex;
                break;
            } else {
                const accordionItems = accordion.navItems;
                //console.info(`Nav construct checking accordion '${accordion.label}' items (links)`, accordionItems);
                for (let accordionItemIndex = 0; accordionItemIndex < accordionItems.length; accordionItemIndex++) {//for each menu
                    const menuItem = accordionItems[accordionItemIndex];
                    //console.info(`Nav construct checking item/link '${menuItem.label}'`, menuItem);
                    if (menuItem.url && menuItem.url.toLowerCase() == location) {
                        accordionindex = accordionIndex;
                        menuIndex = accordionItemIndex;
                        break;
                    }
                    if (menuItem.subMenuItems) {
                        const subMenu = menuItem.subMenuItems;
                        //console.info(`Nav construct checking accordion '${accordion.label}' menuItem  '${menuItem.label}' subMenu '${subMenu.label}'`, subMenu);
                        if (subMenu.url && subMenu.url.toLowerCase() == location) {
                            accordionindex = accordionIndex;
                            menuIndex = accordionItemIndex;
                            break;
                        } else {
                            const subMenuItems = subMenu.menuItems ? subMenu.menuItems : [];
                            for (let subMenuItemIndex = 0; subMenuItemIndex < subMenuItems.length; subMenuItemIndex++) {//for each submenu
                                const subMenuItem = subMenuItems[subMenuItemIndex];
                                if (subMenuItem.url && subMenuItem.url.toLowerCase() == location) {
                                    accordionindex = accordionIndex;
                                    menuIndex = accordionItemIndex;
                                    subMenuIndex = subMenuItemIndex;
                                    break;
                                }
                            }
                        }

                    }
                    if (accordionindex !== -1) break;
                }
            }

            if (accordionindex !== -1) break;
        }
        //console.info(`Nav construct activeAccordion '${accordionindex}' acitveAccordionMenu '${menuIndex}' activeSubMenu '${subMenuIndex}' activemenu '${activeMenu}'`);

        
    }
    return {
        activeAccordion: accordionindex,
        activeAccordionMenu: menuIndex,
        activeSubMenu: subMenuIndex
    };
}

export default useInitialState;